import axios from 'axios'
import store from '@store'
import Util from 'vue-convenia-util'
import { AUTH_TOKEN, AUTH_LOGOUT, AUTH } from '@store/types'
import Locale from 'vee-validate/dist/locale/pt_BR.js'
import Validate, { Validator } from 'vee-validate'
import '@/customValidators/index.js'

// convenia components
import Components from './vue-convenia-components'

const dictionary = {
  pt_BR: {
    messages: {
      required: 'Campo obrigatório'
    }
  }
}

function checkError (m, s) {
  const { token: hasToken, expires_at } = store.getters[AUTH]
  const isLogged = (Date.now() < expires_at) && hasToken

  const messages = ['token_not_provided', 'Unauthorized', 'token_invalid', 'token_expired', 'user_not_found', 'Token not provided', 'User not found']

  const unauthorized = messages.includes(m)

  const isArray = Array.isArray(m) && unauthorized
  const isString = typeof m === 'string' && messages.includes(m)
  const isStatus = s && (s === 401 || s === 403)

  if (!isLogged && (isArray || isString || isStatus)) {
    store.dispatch(AUTH_LOGOUT)
  }
}

function deleteQueryProperties (query) {
  const properties = ['data {', 'current_page', 'from', 'total', 'to', 'per_page']

  const count = query.split('}').length
  const split = query.split('}')
  let newSplit = split[0]

  for (var i = 1; i < count; i++) {
    if (i !== count - 3) {
      newSplit = newSplit.concat('}', split[i])
    }
  }
  properties.forEach(property => {
    newSplit = newSplit.replaceAll(property, '')
  })

  return newSplit
}

axios.interceptors.request.use(({ graphQL, ...config } = {}) => {
  const newQuery = config.params ? deleteQueryProperties(config.params.query) : ''
  const mocksRegisteredQueries = []
  const isGraphQLMockRequest = !graphQL && config.baseURL === process.env.GRAPHQL
  const isGraphQLRequest = graphQL || isGraphQLMockRequest
  const checkMocksRegisteredQueries = isGraphQLMockRequest ? mocksRegisteredQueries.some(matchQuery =>
    config.params.query.toLowerCase().includes(matchQuery.toLowerCase())) : ''
  const hasSomeMocksQuery = !isGraphQLMockRequest ? '' : checkMocksRegisteredQueries
  if (hasSomeMocksQuery && isGraphQLMockRequest) config.params.query = newQuery
  const graphQLBaseURL = hasSomeMocksQuery && isGraphQLMockRequest ? `${process.env.GRAPHQL}/mock` : process.env.GRAPHQL

  const token = store.getters[AUTH_TOKEN]
  const baseURL = isGraphQLRequest ? graphQLBaseURL : (config.baseURL || process.env.API)
  const headers = {
    ...config.headers,
    ...token ? { 'Authorization': `Bearer ${token}` } : {}
  }
  return { ...config, baseURL, headers }
})

axios.interceptors.response.use(
  (response) => {
    checkError(response.data.errors || [])
    return response
  },
  (error = {}) => {
    const { status } = error.response || {}
    const { error: e, errors } = error.response?.data || {}

    checkError((e || errors || []), status)

    return Promise.reject(error)
  }
)

export default (Vue) => {
  Util.integrate('vee-validate', Validator)
  Validator.localize('pt_BR', Locale)
  Vue.use(Components)
  Vue.use(Validate, { locale: 'pt_BR', inject: true, dictionary })
  Vue.use(Util, {
    formatters: true,
    formatFilters: true
  })
}



// WEBPACK FOOTER //
// ./src/plugins.js